import React, { useEffect, useState, useRef } from 'react';
import Loading from '../../components/shared/Loading';
import http from '../../utils/http';
import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';
import { DataGrid } from 'devextreme-react';
import { useSelector } from 'react-redux'
import { Column, Export, Summary, TotalItem, GroupItem, FilterRow } from 'devextreme-react/data-grid';
import { cellRender, cellRenderBold, toMoney } from '../../utils/common';
import useAuthorization from '../../hooks/useAuthorization';
import { resources } from '../../data/app';

const ItemsMasVendidos = () => {
    const [ authorized ] = useAuthorization(resources.verProductosMasVendidos);
    const { user } = useSelector(store => store);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    let dataGrid = useRef();

    useEffect(() => {
        http('reports/BestSellingProducts').asPost({ areaId: user.areaId }).then(resp => {

            setData(resp);
            setLoading(false);

        });
    }, []);


    const title = 'Productos Más Vendidos';

    if (loading) return <Loading />;

    return authorized(

        <div className=''>
            <Title title={title} />
            <BlockHeader title={title} />
            <DataGrid
                ref={dataGrid}
                keyExpr="productId"
                selection={{ mode: 'single' }}
                dataSource={data}
                showBorders={true}
                showRowLines={true}
                hoverStateEnabled={true}
            >

                <Export enabled={true} fileName={title} allowExportSelectedData={true} />
                <FilterRow visible={true} />
                <Column dataField="productId" caption="Código" width={70} visible={false} />
                <Column dataField="internalCode" caption="Código" width={90} />
                <Column dataField="product" caption="Producto" />
                <Column dataField="ultFechaVenta" caption="Último Movimiento" width={120} dataType="date" format="dd/MM/yyyy" />
                <Column dataField="categoria" caption="Categoría" width={70} />
                <Column dataField="stock" caption="Existencias" width={100} />
                <Column dataField="vecesVendido" caption="Veces Vendido" width={100} />
                <Column dataField="unidadesVendidas" caption="Unidades Vendidas" width={100} />
                <Column dataField="cost" caption="Costo" cellRender={cellRender()} width={100} />
                <Column dataField="price" caption="Precio" cellRender={cellRender()} width={100} />
                <Column dataField="costoTotal" caption="Costo Total" cellRender={cellRender()} width={120} />
                <Column dataField="precioTotal" caption="Precio Total" cellRender={cellRender()} width={120} />
                <Column dataField="utilidades" caption="Utilidades" cellRender={cellRenderBold()} width={120} />
                <Column dataField="utilidadPercent" caption="Utilidad %" width={90} />
                <Summary>

                    <TotalItem column="product" summaryType="sum" customizeText={() => 'Totales :'} />

                    <TotalItem column="costoTotal" summaryType="sum" customizeText={toMoney} />
                    <TotalItem column="precioTotal" summaryType="sum" customizeText={toMoney} />
                    <TotalItem column="utilidades" summaryType="sum" customizeText={toMoney} />

                </Summary>
            </DataGrid>
        </div>
    );
}

export default ItemsMasVendidos;
